import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/useAuthStore'
import { useAppStore } from './stores/useAppStore'
import { initializePushNotifications, registerFamilyUpdateHandler } from './services/pushNotificationService'
import { useNotificationStore } from './stores/useNotificationStore'
import { watch } from 'vue'
import { useVaccineDefinitions } from './stores/useVaccineDefinitions'
import { reportClientVersion } from './services/clientVersionService'
import './style.css'

const app = createApp(App)

// 全局錯誤處理
app.config.errorHandler = (err, _instance, info) => {
  console.error('Vue 錯誤:', err, info)
}

window.addEventListener('error', (event) => {
  console.error('全局錯誤:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('未處理的 Promise 拒絕:', event.reason)
})

const pinia = createPinia()
app.use(pinia)

app.use(router)

const authStore = useAuthStore()
const vaccineDefinitions = useVaccineDefinitions()

watch(
  () => authStore.uid,
  (uid) => {
    if (uid) {
      reportClientVersion(uid, vaccineDefinitions.currentVersion).catch(error => {
        console.warn('[ClientVersion] 版本回報失敗，不影響 App 使用', error)
      })
    }
  },
  { immediate: true }
)

  ; (async () => {
    try {
      await authStore.init()

      // 初始化遠端推播（在背景進行，不阻塞）
      const notificationStore = useNotificationStore()
      const appStore = useAppStore()
      initializePushNotifications((token: string) => {
        notificationStore.saveFCMToken(token).catch(() => { })
      }).catch(() => { })

      // 收到家庭更新通知時，重載雲端資料
      registerFamilyUpdateHandler(async () => {
        await appStore.initFromCloud()
      })

      app.mount('#app')
    } catch (error) {
      console.error('應用啟動失敗:', error)
      // 即使失敗也顯示錯誤訊息給用戶
      document.body.innerHTML = `
      <div style="padding: 20px; font-family: sans-serif;">
        <h1>應用啟動失敗</h1>
        <p>錯誤: ${error instanceof Error ? error.message : '未知錯誤'}</p>
        <p>請重新開啟應用程式</p>
        <button onclick="location.reload()" style="margin-top: 20px; padding: 10px 20px;">重新載入</button>
      </div>
    `
    }
  })()
